import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appBaseUrl } from "../../config/apiConfig";
import {
  TApproveAgentRequest,
  TCreateAgentRequest,
  TCreateAgentResponse,
  TUpdateAgentUrlResponse,
} from "./types";

export const createAgent = (
  postObj: TCreateAgentRequest,
): Promise<TCreateAgentResponse> => {
  return appBaseUrl
    .post("/krab/agents/create", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const updateAgentUrl = (
  uid: string,
): Promise<TUpdateAgentUrlResponse> => {
  return appBaseUrl
    .post(`/krab/agents/${uid}/dashboard/session`, {
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getAgentStatus = (
  uid: string,
): Promise<TUpdateAgentUrlResponse> => {
  return appBaseUrl
    .get(`/krab/agents/${uid}/status`, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const deleteAgent = (uid: string) => {
  return appBaseUrl
    .delete(`/krab/agents/${uid}`, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getAgentPairingList = (uid: string): Promise<string> => {
  return appBaseUrl
    .get(`/krab/agents/${uid}/pairing`, {
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const approvedAgentTgBot = (
  uid: string,
  postObject: TApproveAgentRequest,
) => {
  return appBaseUrl
    .post(`/krab/agents/${uid}/pairing/approve`, postObject, {
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const revokeAgentPairing = (
  uid: string,
  telegramId: string,
): Promise<string> => {
  return appBaseUrl
    .delete(`/krab/agents/${uid}/pairing/approved/${telegramId}`, {
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
